import { z } from 'zod/v3';
import { SystemClassifierItemSchema } from './SystemClassifierItemSchema';
import { EntitySchema } from '../../common/utils/schema/EntitySchema';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './SystemClassifierSchema.translations.json';
import { createPaginationSchema } from '../../common/utils/schema/paginationSchema';
import { zCode, zDescription, zName } from '../../common/utils/schema/common';
import { zSequenceNumber } from '../../common/utils/schema/zSequenceNumber';
import { errorMap } from '../../common/utils/schema/errorMap';

const { addTranslations, t } = i18nNsFactory('system-classifier-schema');
addTranslations(translations);

export const systemClassifierCodes = [
  'CONFIDENTIALITY_STATUS', //Konfidentsiaalsuse staatus
  'DOMAIN', // Valdkond
  'FREQUENCY', // Sagedus
  'DATA_PROVIDER_GROUP', // Andmeesitajate grupp
  'DATA_OBJ_GRP_VER_STATUS', // Sisendi/väljundi kirjelduse versiooni staatus
  'DATA_ORIGIN', //Andmete päritolu
  'DATA_SOURCE_TYPE', // Andmete laadimise viis
  'DATA_TYPE', // Andmetüüp
  'DIMENSION_TYPE', //Dimensiooni tüüp
  'REPORT_RECIPIENT', // Saaja
  'PERIOD_DATA_TYPE', // Perioodi andmetüüp
  'MULTIPLIER', // Kordaja
  'INDICATOR_UNIT', // Näitaja ühik
  'DATA_LOADING_STATUS', // Andmete olek
  'DATA_SUBJECT_ATTRIBUTE', // Andmesubjekti ajaloo andmeväli
  'ALGORITHM_STATUS', // Algoritmi staatus
  'EXECUTION_METHOD', // Andmete laadimise meetod
  'PERIOD_LOADING_TYPE', // Laaditavad väärtuspäevad
  'HOLIDAY', // Riigipüha
  'OUTPUT_TYPE', // Väljundi kirjelduse liik
  'PREDEFINED_MONTHS', // Perioodilisuse kiirvalikud - kalendrikuud
  'PERIODICITY_MONTHS', // Perioodilisuse valikud - kalendrikuud
  'PREDEFINED_WEEKDAYS', // Perioodilisuse kiirvalikud - nädalapäevad
  'PERIODICITY_WEEKDAYS', // Perioodilisuse valikud - nädalapäevad
  'PREDEFINED_DAYS', // Perioodilisuse kiirvalikud - päevad kalendrikuus
  'PERIODICITY_DAYS', // Perioodilisuse valikud - päevad kalendrikuus
  'PREDEFINED_HOURS', // Perioodilisuse kiirvalikud - tunnid
  'PERIODICITY_HOURS', // Perioodilisuse valikud - tunnid
  'PREDEFINED_MINUTES', // Perioodilisuse kiirvalikud - minutid
  'PERIODICITY_MINUTES', // Perioodilisuse valikud - minutid
  'MAPPING_JOIN_TYPE', // Vastavustabeli joini tüüp
  'IND_STATUS_RULE_TYPE', // Näitaja staatuse määramise reegli liik
  'IND_VALUE_RULE_TYPE', // Näitaja väärtuse määramise reegli liik
  'ALGORITHM_ELEMENT_FUNCTION', //Algoritmide elemendid ja funktsioonid
  'CLASSIFIER_DATA_TYPE', //Kategooria koodi mustri tüüp
  'SYSTEM_CONFIGURATION', // Süsteemi konfiguratsiooni parameetrid
] as const;

export const SystemClassifierBasicSchema = EntitySchema.extend({
  code: z.enum(systemClassifierCodes).or(z.string()),
  name: z.string(),
  description: z.string().nullable(),
  itemCount: z.number(),
  userManaged: z.boolean(),
});

export const SystemClassifierSchema = SystemClassifierBasicSchema.extend({
  systemClassifierItems: SystemClassifierItemSchema.array(),
});

export const SystemClassifierPageSchema = createPaginationSchema(
  SystemClassifierBasicSchema,
);

export const SystemClassifierItemValidFormDataSchema = z.object({
  id: z.number().nullable(),
  code: zCode(),
  name: zName(errorMap(() => t('validation.name.required'))).min(1),
  sequenceNumber: zSequenceNumber(),
  parameters: zName().nullable(),
});

export const SystemClassifierValidFormDataSchema = z.object({
  name: zName(errorMap(() => t('validation.name.required'))).min(1),
  description: zDescription().nullable(),
  systemClassifierItems: SystemClassifierItemValidFormDataSchema.array(),
});
